import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import Styl from './index.styl';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
